<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
    >
        <path
            d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6zm2 0v7.586l3.293-3.293a1 1 0 0 1 1.414 0L12 13.586l2.293-2.293a1 1 0 0 1 1.414 0L20 15.586V6H4zm0 12h16v-.586l-4-4-2.293 2.293a1 1 0 0 1-1.414 0L9 12.414l-3 3V18zm6-8a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
        />
    </svg>
</template>

<script>
export default { name: "PhotoIcon" };
</script>
